exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.data-url_code_fTTSN {\r\n    display: block;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 100%;\r\n    height: 5rem;\r\n    min-height: 3rem;\r\n    border: 1px solid var(--ui-black-transparent);\r\n    border-radius: 0.25rem;\r\n    padding: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-family: monospace;\r\n    margin: 0.5rem 0;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"code": "data-url_code_fTTSN"
};